import { getRuntimeFramework } from '../../utils/getRuntimeFramework.mjs';
import { useNextFlexRouter } from './useNextFlexRouter.mjs';
import { usePodoFlexRouter } from './usePodoFlexRouter.mjs';

const useFlexRouter = getRuntimeFramework() === "next" ? useNextFlexRouter : usePodoFlexRouter;

export { useFlexRouter };
//# sourceMappingURL=index.mjs.map
